import React from 'react';
import { createRoot } from 'react-dom/client';

import PageContainer from './containers/PageContainer';
import { rootNode } from './configs';

document.addEventListener('DOMContentLoaded', () => {
  if (!rootNode) return;
  const root = createRoot(rootNode);
  root.render(<PageContainer />);
});
